import * as Yup from 'yup';
import { DateTime } from 'luxon';
import styled from '@emotion/styled';

import ServiceList from './Components/ServiceList';
import ScheduleType from './Components/ScheduleType';

import Summary from './Components/Summary';
import RecurringOption from './Components/RecurringOption';

import { BasicFlex } from '../../utils/Common';

import { isEmpty } from 'lodash';

import { formatCurrency, formatPhoneNumber } from '../../utils/util';

import CustomerInfo from './Components/CustomerInfo';

import MediaZone from './Components/MediaZone';

import EditCustomer from '../Customers/EditCustomer';

const ServiceItemDisplay = styled(BasicFlex)`
  flex-direction: column;
  align-items: flex-start;
  gap: .5rem;
  .main-title {

  }
  .add-info {
    font-size: 1.3rem;
    color: ${props => props.theme.colors.mildText};
  }
`;

const displayLabel = (option) => {
  return (
   <ServiceItemDisplay>
    <div className="main-title">
      {option.full_name}
    </div>
    <div className="add-info">
      {formatPhoneNumber(option.mobile_phone)} &middot; {option.email}
    </div>
   </ServiceItemDisplay>
  )
}

const fields = [
  {
    fieldType: "Component",
    Component: <ScheduleType />,
    name: "appointment_type",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "divider",
    header: "Appointment Details",
    size: {xs: 12, lg: 12},
  },
  { 
    fieldType: "debounceSearchSolo",
    formFieldType: "select",
    select: [],
    name: "customer_id",
    label: "Select Customer",
    url: "customers",
    fieldName: "customer_id",
    displayField: "full_name",
    formUpdates: [{name: "customer_name", field: "full_name"}, {name: "customer_phone", field: "mobile_phone"}],
    setDisplayField: "customer_name",
    displayLabel,
    newItemTitle: "Customer",
    server: true,
    FormComponent: <EditCustomer dialog={true}/>,
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "formField",
    formFieldType: "date",
    name: "appointment_date",
    label: "Date",
    type: "date",
    size: {xs: 12, lg: 3},
  },
  {
    fieldType: "formField",
    formFieldType: "time",
    name: "start_time",
    label: "Start Time",
    type: "time",
    size: {xs: 12, lg: 3},
  },
  // { 
  //   fieldType: "debounceSearchSolo",
  //   formFieldType: "select",
  //   select: [],
  //   name: "stylist_id",
  //   label: "Select Stylist",
  //   url: "stylists",
  //   fieldName: "stylist_id",
  //   displayField: "full_name",
  //   formUpdates: [{name: "stylist_name", field: "full_name"}],
  //   setDisplayField: "stylist_name",
  //   // FormComponent: <EditServiceCategory dialog={true}/>,
  //   size: {xs: 12, lg: 4},
  // },
  {
    fieldType: "formField",
    formFieldType: "switch",
    name: "notify_sms",
    label: "Send SMS Notification",
    type: "checkbox",
    size: {xs: 12},
  },
  {
    fieldType: "Component",
    Component: <CustomerInfo />,
    name: "customer_info",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Services",
    name: "services",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <ServiceList />,
    name: "service_list",
    size: {xs: 12, lg: 12},
  },
  // {
  //   fieldType: "divider",
  //   header: "Upload Media",
  //   name: "media",
  //   size: {xs: 12, lg: 12},
  // },
  // {
  //   fieldType: "Component",
  //   Component: <MediaZone />,
  //   name: "media_zone",
  //   size: {xs: 12, lg: 12},
  // },
  // {
  //   fieldType: "divider",
  //   header: "Appointment Notes",
  //   name: "notes",
  //   size: {xs: 12, lg: 12},
  // },
  // {
  //   fieldType: "formField",
  //   formFieldType: "text",
  //   name: "notes",
  //   label: "Notes",
  //   type: "text",
  //   multiline: true,
  //   rows: 4,
  //   size: {xs: 12, lg: 12},
  // },
  // {
  //   fieldType: "divider",
  //   header: "Summary",
  //   name: "summary",
  //   size: {xs: 12, lg: 12},
  // },
  // {
  //   fieldType: "Component",
  //   Component: <Summary />,
  //   name: "summary",
  //   size: {xs: 12, lg: 12},
  // }
]

const blockFields = [
  {
    fieldType: "Component",
    Component: <ScheduleType />,
    name: "appointment_type",
    size: {xs: 12, lg: 6},
  },
  {
    fieldType: "divider",
    header: "Event Details",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <RecurringOption />,
    name: "summary",
    size: {xs: 12, lg: 12},
  }
]

const initialValues = {
  appointment_type: 'customer',
  customer_id: '',
  stylist_id: '',
  appointment_date: DateTime.local(),
  start_time: DateTime.local(),
  notes: '',
  notify_sms: true,
  media: [],
  clients: [],
  services: [],
}

const blockIntitialValues = {
  appointment_type: 'personal_block',
  title: '',
  stylist_id: '',
  appointment_date: DateTime.local(),
  start_time: DateTime.local(),
  end_time: DateTime.local(),
  is_recurring: false,
  recurrence_pattern: {
    frequency: 'daily',
    start_date: DateTime.local(),
    end_date: DateTime.local(),
  },
  notes: '',
}

const additionalState = {
  title: '',
  block_color: '',
  customer_name: '',
  customer_phone: '',
  stylist_name: '',
  end_time: null,
  duration_in_minutes: 0,
  total: 0
}

const schema = Yup.object().shape({
  customer_id: Yup.string().when('appointment_type', {
    is: 'customer',
    then: (schema) => schema.required('Customer is required for appointments'),
    otherwise: (schema) => schema.nullable().optional()
  }),
  appointment_date: Yup.string().when('appointment_type', {
    is: 'customer',
    then: (schema) => schema.required('Appointment date is required for customer appointments'),
    otherwise: (schema) => schema.nullable().optional()
  }),
  title: Yup.string().when('appointment_type', {
    is: (val) => val !== 'customer',
    then: (schema) => schema.required('Event Title is required for personal and public Events'),
    otherwise: (schema) => schema.nullable().optional()
  }),
  end_time: Yup.mixed()
  .nullable()
  .test('end-after-start', 'End time must be after start time', function (end_time) {
    const { start_time } = this.parent;
    if (!start_time || !end_time) return true;
    return end_time > start_time; // equivalent to end_time.valueOf() > start_time.valueOf()
  }),
  services: Yup.array()
    .when('appointment_type', {
      is: 'customer',
      then: (schema) => schema.of(
        Yup.object().shape({
          name: Yup.string().required('Service name is required'),
          duration_in_minutes: Yup.number().required('Service duration is required'),
          service_price: Yup.number().required('Service price is required'),
          wig_id: Yup.string().nullable(),
          wig_source: Yup.string(),
          stylist_id: Yup.string().required('Stylist is required'),
          inventory_id: Yup.string(),
        })
      ).min(1, 'At least one service is required for customers'),
      otherwise: (schema) => schema.notRequired().nullable(),
    })
  .required('Service list is required')
});

const parseData = (data) => {
  const parsed = {...data, recurrence_pattern: {...data.recurrence_pattern}};
  parsed.appointment_date = DateTime.fromISO(data.appointment_date);
  parsed.start_time = DateTime.fromISO(data.start_time);
  parsed.end_time = DateTime.fromISO(data.end_time);
  if (parsed.stylist_id) parsed.stylist_id = data.stylist_id.toString();
  if (parsed.customer_id) parsed.customer_id = data.customer_id.toString();

  if (parsed.recurrence_pattern && !isEmpty(parsed.recurrence_pattern)) {
    parsed.recurrence_pattern.start_date = DateTime.fromISO(parsed.recurrence_pattern.start_date);
    parsed.recurrence_pattern.end_date = DateTime.fromISO(parsed.recurrence_pattern.end_date);
  }
  return parsed
}

export { fields, initialValues, schema, additionalState, parseData, blockFields, blockIntitialValues };